export class PendingTransactionsRegistry {
  private readonly pendingTransactions = new Map<string, string>();

  public addPendingTransaction(transactionId: string, searchParams: string) {
    this.pendingTransactions.set(transactionId, searchParams);
  }

  public popPendingTransaction(transactionId: string) {
    const searchParams = this.pendingTransactions.get(transactionId);
    this.pendingTransactions.delete(transactionId);

    return searchParams;
  }
}

export const pendingTransactionsRegistry = new PendingTransactionsRegistry();
